<!-- <p>partner-activity works!</p> -->
<router-outlet></router-outlet>